import { Chart as ChartJS, Plugin } from 'chart.js';

import { CHART_INK } from './chartTokens';

/** Запас справа под подпись значения у конца столбика, px. */
export const CHART_VALUE_LABEL_PAD = 56;

export interface IChartValueLabels {
  texts: ReadonlyArray<string | null>;
  negative?: ReadonlyArray<boolean>;
}

/**
 * ТЗ 0103 — подпись значения у конца горизонтального столбика (без новой
 * зависимости): число рядом со столбиком, а не только в подсказке. Подписи
 * — по строкам (`texts[i]`), у стека — за самым дальним сегментом;
 * отрицательное значение — слева от столбика.
 *
 * Пакет 2: подписи читаются при каждой отрисовке (`read`), а не замыкаются
 * при создании: react-chartjs-2 берёт плагины только при создании графика,
 * и после смены показателя или фильтра подписи оставались старыми.
 */
export const chartValueLabelsPlugin = (
  read: () => IChartValueLabels,
): Plugin<'bar'> => ({
  id: 'erpValueLabels',
  afterDatasetsDraw: (chart: ChartJS<'bar'>) => {
    const { texts, negative = [] } = read();
    const { ctx } = chart;
    ctx.save();
    ctx.font = '600 11px sans-serif';
    ctx.fillStyle = CHART_INK;
    ctx.textBaseline = 'middle';
    texts.forEach((text, index) => {
      if (!text) return;
      let edge: number | null = null;
      let y: number | null = null;
      const left = Boolean(negative[index]);
      chart.data.datasets.forEach((_dataset, datasetIndex) => {
        if (!chart.isDatasetVisible(datasetIndex)) return;
        const element = chart.getDatasetMeta(datasetIndex).data[index] as
          | { x: number; y: number }
          | undefined;
        if (!element || !Number.isFinite(element.x)) return;
        if (edge === null || (left ? element.x < edge : element.x > edge)) {
          edge = element.x;
        }
        if (y === null) ({ y } = element);
      });
      if (edge === null || y === null) return;
      ctx.textAlign = left ? 'right' : 'left';
      ctx.fillText(text, left ? edge - 4 : edge + 4, y);
    });
    ctx.restore();
  },
});
